// The mobile floating-action-button recipe, canonicalized from web's
// DoBoxMobileFab (`apps/web/src/components/DoBoxHeader/components/DoBoxMobileFab/`).
// Chakra-free class strings a consumer spreads onto its own Chakra `Button`.
// `.tsx` extension is deliberate: both apps' Tailwind `content` globs only
// scan `libs/ui/src/**/*.tsx`, not `*.ts`.
//
// `button` is size/shape/shadow/transition/z only — it carries no position,
// so every consumer must pair it with one of the position keys below.
// z-[1510] must stay above the FloatingAssistant pill (z-1500) and below
// modals (1900).
export const MOBILE_FAB_STYLES = {
  button:
    'shrink-0 min-w-0 h-14 w-14 p-0 flex items-center justify-center z-[1510] rounded-semantic shadow-md hover:shadow-lg active:scale-[0.98] transition-all duration-200 motion-reduce:transition-none',
  // apps/web's DoBox: sits above the mobile bottom nav.
  positionAboveBottomNav: 'fixed bottom-16 right-4',
  // Any app with no bottom nav: safe-area-aware bottom offset.
  positionDefault:
    'fixed right-4 bottom-[calc(1rem+env(safe-area-inset-bottom))]',
} as const;
